// src/components/EditorToolbar.js
import React, { useCallback } from 'react';
import { FaBold, FaItalic, FaUnderline, FaLink, FaListOl, FaListUl, FaAlignLeft, FaAlignRight, FaAlignCenter, FaHighlighter } from 'react-icons/fa';

const EditorToolbar = ({ editor }) => {
  const setLink = useCallback(() => {
    if (!editor) return;
    const previousUrl = editor.getAttributes('link').href;
    const url = window.prompt('URL', previousUrl);

    if (url === null) {
      return;
    }
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink().run();
      return;
    }
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
  }, [editor]);

  if (!editor) {
    return null;
  }

  return (
    <div id="toolbar">
      <span className="toolbar-group">
        <select onChange={(e) => {
            const level = e.target.value ? parseInt(e.target.value, 10) : 0;
            if (level === 0) {
                editor.chain().focus().setParagraph().run();
            } else {
                editor.chain().focus().toggleHeading({ level }).run();
            }
        }}
        className="toolbar-select"
        value={editor.isActive('heading') ? editor.getAttributes('heading').level : 0}
        >
          <option value="2">Cabeçalho 2</option>
          <option value="3">Cabeçalho 3</option>
          <option value="0">Parágrafo</option>
        </select>
      </span>
      
      <span className="toolbar-group">
        <button onClick={() => editor.chain().focus().toggleBold().run()} className={editor.isActive('bold') ? 'is-active' : ''}><FaBold /></button>
        <button onClick={() => editor.chain().focus().toggleItalic().run()} className={editor.isActive('italic') ? 'is-active' : ''}><FaItalic /></button>
        <button onClick={() => editor.chain().focus().toggleUnderline().run()} className={editor.isActive('underline') ? 'is-active' : ''}><FaUnderline /></button>
        <button onClick={() => editor.chain().focus().toggleHighlight().run()} className={editor.isActive('highlight') ? 'is-active' : ''}>
          <FaHighlighter />
        </button>
      </span>
      
       <span className="toolbar-group">
        <button onClick={() => editor.chain().focus().toggleBulletList().run()} className={editor.isActive('bulletList') ? 'is-active' : ''}><FaListUl /></button>
        <button onClick={() => editor.chain().focus().toggleOrderedList().run()} className={editor.isActive('orderedList') ? 'is-active' : ''}><FaListOl /></button>
      </span>
      
      <span className="toolbar-group">
        <button onClick={() => editor.chain().focus().setTextAlign('left').run()} className={editor.isActive({ textAlign: 'left' }) ? 'is-active' : ''}><FaAlignLeft /></button>
        <button onClick={() => editor.chain().focus().setTextAlign('center').run()} className={editor.isActive({ textAlign: 'center' }) ? 'is-active' : ''}><FaAlignCenter /></button>
        <button onClick={() => editor.chain().focus().setTextAlign('right').run()} className={editor.isActive({ textAlign: 'right' }) ? 'is-active' : ''}><FaAlignRight /></button>
      </span>

      <span className="toolbar-group">
            <button onClick={setLink} className={editor.isActive('link') ? 'is-active' : ''}>
                <FaLink />
            </button>
        </span>
    </div>
  );
};

export default EditorToolbar;